import MailingList from "./MailingList";

export default MailingList;